import React, { useState, useEffect } from 'react';
import { API } from 'aws-amplify';
import Test3 from './Test3';


function EventSeatListPrintOut (props) {

    const [event, setEvent] = useState({eventName: '',eventDate: ''});
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState({loading: false});
    const [reserved, setReserved] = useState([]);
    const [reservationName, setReservationName] = useState('');
    const [purchasePrice, setPurchasePrice] = useState(35.00);
    const [events, setEvents] = useState({});
    const [seats, setSeats] = useState({});
    const [seat, setSeat] = useState({});

    console.log('SSKK', props.sk);

    function chgClassName(seat, status, reserved){
        if(reserved.indexOf(seat) > -1){
          return 'reserved';
        }else{
          return status;
        }
    }

    function onClickData(seat, status, reserved, setReserved) {
        if (seat === 'sold') {
          alert("Seat Sold");
        }else{   
            if((status !== 'sold') && (status !== 'ns')){
                if(reserved.indexOf(seat) > -1 ) {
                    //alert("Already Reserved");
                    //const temparray = reserved.filter(remseat => !(remseat.id === reserved.indexOf(seat)));
                    setReserved([])
                    console.log("SPOT5:", reserved)
                }else{
                    setReserved([...reserved, seat]);
                    console.log("SPOT6:", reserved)
                }    
            }
        }
        console.log(seat)
        console.log(status)
        console.log(reserved)
    }

    function soldSeatList(seats) {
        let seatList = [];
        let outString = '';
        console.log("SEATA1:",seats)

        Object.entries(seats).map(([key, value]) => {
            //console.log("SEATSTAT:",key)
            //console.log("SEATSTAT:",value.seatStatus)
            if(value.seatStatus === 'sold'){
                seatList.push(value.guest + ' --- ' + key)
            }
            })
            const seatListSorted = seatList.sort((a, b) => a.localeCompare(b))
            //console.log(seatListSorted)
        return (
            <div>
                {seatListSorted.map( seatOut => { 
                    return (<p>{seatOut} </p>)
                })
                }
            </div>
        )
    }

    function getData(setSeats, setEvents, setRows, setReserved, skk) {
        setReserved([])
        let apiName = 'ticket57api';
        let path = '/items/object/123/' + skk;
        let myInit = { // OPTIONAL
            headers: {} // OPTIONAL
        }
        
        API
        .get(apiName, path, myInit)
        .then(response => {
            console.log("SPOT7")
            setSeats(response.seats);
            setEvents(response);
            setRows(response.rows);
            console.log("API2")
        })
        .catch(error => {
            console.log("SPOT3")
            console.log(error);
            console.log(error.response);
        });
    }

    function postData(customerId,eventId,reserved,status,purchasePrice,seatGuest, skk){
        let apiName = 'ticket57api';
        let path = '/items';
        let x = 0;
        reserved.forEach( async reservedSeat => {
          let seatId = reservedSeat;
          let seatStatus = status;
          let guest = seatGuest;
          let currDateTime = getFormattedDate();
  
          let myInit = {
            body: {         
                    customerId: customerId,
                    eventId: eventId,
                    purchaseDate: currDateTime,
                    seatId: seatId,
                    seatStatus: seatStatus,
                    purchasePrice: purchasePrice,
                    seatGuest: seatGuest              
                },
            headers: {} // OPTIONAL
          }

          let response = API.post(apiName, path, myInit);
          console.log(response);
          ///do something with response
    
           Promise.resolve(response).then(function(value) {
            console.log(value);
            console.log(value.statusCode);
            getData(setSeats, setEvents, setRows, setReserved, props.sk);
    
            if(value.statusCode === 200){
              console.log("This is cool...");
            }else{
                console.log("SPOT2");
            }
          })
          .catch(function(error) {
            console.log('Request failed Mark', error);
            
          });
        })
    }

    function getFormattedDate(){
      var d = new Date();
      d = d.getFullYear() + "-" + ('0' + (d.getMonth() + 1)).slice(-2) + "-" + ('0' + d.getDate()).slice(-2) + " " + ('0' + d.getHours()).slice(-2) + ":" + ('0' + d.getMinutes()).slice(-2) + ":" + ('0' + d.getSeconds()).slice(-2);
      return d;
    }

    useEffect(() => {
        console.log('trigger use effect hook');
        console.log(loading);

        let apiName = 'ticket57api';
        let path = '/items/object/123/' + props.sk;
        let myInit = { // OPTIONAL
            headers: {} // OPTIONAL
        }
        
        API
        .get(apiName, path, myInit)
        .then(response => {
            console.log("SPOT2")
            console.log("API1")
            console.log(response)
            console.log(response.seats)
            setSeats(response.seats);
            setEvent({...event,["eventName"]: response.eventName,["eventDate"]: response.dateTime});
            setRows(response.rows);
            setEvents(response);
            setLoading(false);
            console.log("API2")
        })
        .catch(error => {
            console.log("SPOT3")
            console.log(error);
            console.log(error.response);
        });


    }, [props.sk]);
    
    const text = loading ? <div>loading...</div> : <div><h2>{event.eventName}<br />{event.eventDate}</h2></div>;
    const text2 = soldSeatList(seats);
    

    return (
    <div className="App">
        <header className="App-header">
        <div>  
        {text}
        {text2}
        </div>
        </header>
    </div>
    );
}

export default EventSeatListPrintOut